


















import Vue, { PropType } from 'vue';
import * as api from '@/api';

export default Vue.extend({
    name: 'FilterFileType',
    props: {
        data: {
            type: Array as PropType<api.FilterFileType[]>,
            required: true,
        },
        selectedData: {
            type: Array as PropType<api.FilterFileType[]>,
            required: true,
        },
        showBack: {
            type: Boolean,
            default: true,
        },
        showSearch: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            search: '',
        };
    },
    computed: {
        displayData(): api.FilterFileType[] {
            if (this.search === '') {
                return this.data;
            }
            return this.data.filter((d) => d.name.toLowerCase().includes(this.search.toLowerCase()));
        },
    },
    methods: {
        handleClick(item: api.FilterFileType) {
            const idx = this.selectedData.findIndex((v) => v.name === item.name);
            if (idx === -1) {
                this.selectedData.push(item);
            } else {
                this.selectedData.splice(idx, 1);
            }
        },
    },
    filters: {
        fileExtToImg(ext: string): string {
            // 需求：'.3ds' --> /cdn/icon/file/3ds.png
            return `/cdn/icon/file/${ext.substr(1)}.png`;
        },
    },
});
